import { render, staticRenderFns } from "./MarketItem.vue?vue&type=template&id=e1a9805c&scoped=true"
import script from "./MarketItem.vue?vue&type=script&lang=js"
export * from "./MarketItem.vue?vue&type=script&lang=js"
import style0 from "./MarketItem.vue?vue&type=style&index=0&id=e1a9805c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a9805c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1a9805c')) {
      api.createRecord('e1a9805c', component.options)
    } else {
      api.reload('e1a9805c', component.options)
    }
    module.hot.accept("./MarketItem.vue?vue&type=template&id=e1a9805c&scoped=true", function () {
      api.rerender('e1a9805c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/MarketItem.vue"
export default component.exports